module.exports = __webpack_public_path__ + "assets/icon-consultation-deselected.a46277df.svg";